/* eslint-disable jsx-a11y/img-redundant-alt */

import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.min.css";
import "owl.carousel/dist/assets/owl.theme.default.min.css";
import { useTranslation } from "react-i18next";

const Slider2 = () => {
  const { t, i18n } = useTranslation();

  /*
   * Performans:
   * İlk açılışta yalnızca 1. slider görseli yüklenir.
   * 2. slider görseli sayfanın ilk render'ını engellemesin
   * diye biraz sonra aktif edilir.
   */
  const [loadSecondSlide, setLoadSecondSlide] = useState(false);

  useEffect(() => {
    let timer;

    const loadSecond = () => {
      timer = window.setTimeout(() => {
        setLoadSecondSlide(true);
      }, 1500);
    };

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(loadSecond, {
        timeout: 2500,
      });

      return () => {
        window.cancelIdleCallback(idleId);
        if (timer) window.clearTimeout(timer);
      };
    }

    timer = window.setTimeout(() => {
      setLoadSecondSlide(true);
    }, 2000);

    return () => {
      if (timer) window.clearTimeout(timer);
    };
  }, []);

  const options = {
    items: 1,
    loop: loadSecondSlide,
    margin: 0,
    nav: loadSecondSlide,
    dots: loadSecondSlide,
    autoplay: loadSecondSlide,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    smartSpeed: 600,
    navText: ["‹", "›"],
  };

  const hiddenH1Style = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0,
  };

  const imageStyle = {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  const SlideContent = () => (
    <div className="container">
      <div className="slider-twelev__content">
        <h2 className="slider-twelev__title">
          <div className="title-word">{t("İŞLETMENİZİ")}</div>
          <div className="title-word">{t("DİJİTAL OLARAK")}</div>
          <div className="title-word">{t("BÜYÜTMEK")}</div>
          <div className="title-word">{t("İSTİYORSANIZ")}</div>
        </h2>

        <div className="slider-twelev__btn">
          <a
            href="https://wa.me/905434052825"
            className="thm-btn-twelev"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("HIZLI TEKLİF ALIN!")}
          </a>
        </div>
      </div>
    </div>
  );

  const DecorativeLayer = () => (
    <div className="slider-twelev__layer" aria-hidden="true">
      <div
        className="slider-twelev__layer__bg"
        style={{
          backgroundImage:
            "url(/assets/images/shapes/layer-bg.webp)",
        }}
      />

      <img
        src="/assets/images/resources/layer-1.webp"
        alt=""
        loading="lazy"
        decoding="async"
      />

      <div className="slider-twelev__shape-one">
        <img
          src="/assets/images/shapes/slider-1-shape-1.webp"
          alt=""
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className="slider-twelev__shape-two">
        <img
          src="/assets/images/shapes/slider-1-shape-2.webp"
          alt=""
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  );

  return (
    <section
      className="slider-twelev"
      key={i18n.language}
      aria-label={t("Web Center")}
    >
      <h1 style={hiddenH1Style}>
        {t("Bursa Web Tasarım")} |{" "}
        {t("Profesyonel Web Sitesi Tasarımı")} | Web Center
      </h1>

      <OwlCarousel
        className="banner-carousel owl-theme"
        {...options}
        key={`carousel-${i18n.language}-${loadSecondSlide}`}
      >
        {/* =========================
            1. SLIDE - LCP
        ========================== */}
        <div className="item">
          <div className="slider-twelev__item">
            <div className="slider-twelev__bg">
              <img
                src="/assets/images/background/slider-1-1.webp"
                srcSet="
                  /assets/images/background/slider-1-1-mobile.webp 768w,
                  /assets/images/background/slider-1-1-tablet.webp 1024w,
                  /assets/images/background/slider-1-1.webp 1920w
                "
                sizes="100vw"
                alt={t("Web Center")}
                loading="eager"
                fetchPriority="high"
                decoding="async"
                width="1920"
                height="1080"
                style={imageStyle}
              />
            </div>

            <SlideContent />
            <DecorativeLayer />
          </div>
        </div>

        {/* =========================
            2. SLIDE
            İlk render sırasında DOM'a
            hiç eklenmiyor.
        ========================== */}
        {loadSecondSlide && (
          <div className="item">
            <div className="slider-twelev__item">
              <div className="slider-twelev__bg">
                <img
                  src="/assets/images/background/slider-1-2.webp"
                  alt=""
                  loading="lazy"
                  decoding="async"
                  width="1920"
                  height="1080"
                  style={imageStyle}
                />
              </div>

              <SlideContent />
              <DecorativeLayer />
            </div>
          </div>
        )}
      </OwlCarousel>
    </section>
  );
};

export default Slider2;